import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AdminContext = createContext<any>(null);

export const AdminProvider = ({
                                  children,
                              }: {
    children: React.ReactNode;
}) => {

    const [mediaItems, setMediaItems] = useState<any[]>([]);
    const [ads, setAds] = useState<any[]>([]);
    const [subscribers, setSubscribers] = useState<any[]>([]);
    const [history, setHistory] = useState<any[]>([]);

    const fetchData = async () => {
        try {
            const [mRes, aRes, sRes, nRes] = await Promise.all([
                axios.get('https://api.237showbiz.com/api/media'),
                axios.get('https://api.237showbiz.com/api/ads'),
                axios.get('https://api.237showbiz.com/api/subscribers'),
                axios.get(
                    'https://api.237showbiz.com/api/Notifications?subscriber_id=admin'
                ),
            ]);

            setMediaItems(
                Array.isArray(mRes.data)
                    ? mRes.data
                    : []
            );

            setAds(
                Array.isArray(aRes.data)
                    ? aRes.data
                    : []
            );

            setSubscribers(
                Array.isArray(sRes.data)
                    ? sRes.data
                    : []
            );

            setHistory(
                Array.isArray(nRes.data?.notifications)
                    ? nRes.data.notifications
                    : []
            );
        } catch (err) {
            console.error('AdminContext fetch error:', err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <AdminContext.Provider
            value={{
                mediaItems,
                ads,
                subscribers,
                history,
                fetchData,
            }}
        >
            {children}
        </AdminContext.Provider>
    );
};

export const useAdminContext = () => useContext(AdminContext);